(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5870],{

/***/ 5870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TravelSearchResults_TravelSearchResults; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./blocks/TravelSearchResults/TravelSearchResults.module.css
var TravelSearchResults_module = __webpack_require__(56270);
var TravelSearchResults_module_default = /*#__PURE__*/__webpack_require__.n(TravelSearchResults_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/ImageComponent/index.ts + 1 modules
var ImageComponent = __webpack_require__(87050);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./blocks/Benefits/Benefits.module.scss
var Benefits_module = __webpack_require__(69013);
var Benefits_module_default = /*#__PURE__*/__webpack_require__.n(Benefits_module);
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
;// CONCATENATED MODULE: ./components/icons/BenefitTickIcon.tsx

var BenefitTickIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "15",
        viewBox: "0 0 20 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6.91982 14.6983L0.913086 8.53064L2.68019 6.71621L6.91982 11.0694L17.407 0.30127L19.174 2.11571L6.91982 14.6983Z",
            fill: "#BAA57E"
        })
    });
};
/* harmony default export */ var icons_BenefitTickIcon = (BenefitTickIcon);

// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
;// CONCATENATED MODULE: ./blocks/Benefits/Benefits.tsx








var Benefits = function(param) {
    var benefits = param.benefits, benefitsFootnotes = param.benefitsFootnotes;
    var benefits_title_text = (0,useLocalised/* default */.Z)(translationKeys.benefits_title);
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:700px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: benefits.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Benefits_module_default()).benefitsContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                    weight: "demiBold",
                    color: "black",
                    children: benefits_title_text
                }),
                benefits.map(function(benefit, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Benefits_module_default()).benefitsRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_BenefitTickIcon, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                color: "black",
                                children: benefit
                            })
                        ]
                    }, index);
                }),
                benefitsFootnotes.length > 0 && !isMobile && benefitsFootnotes.map(function(footNote, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Benefits_module_default()).footNotesRow,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Small */.x4, {
                            xs: true,
                            color: "grey-dark",
                            children: footNote
                        })
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var Benefits_Benefits = (Benefits);

// EXTERNAL MODULE: ./blocks/TravelSearchResults/ListItemExtended.module.css
var ListItemExtended_module = __webpack_require__(20010);
var ListItemExtended_module_default = /*#__PURE__*/__webpack_require__.n(ListItemExtended_module);
// EXTERNAL MODULE: ./blocks/TravelSearchResults/Badges.module.css
var Badges_module = __webpack_require__(96731);
var Badges_module_default = /*#__PURE__*/__webpack_require__.n(Badges_module);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./blocks/TravelSearchResults/Badges.tsx




var Badges = function(param) {
    var searchResults = param.searchResults;
    var Badges = [];
    var today = moment_default()();
    var lastYear = moment_default()().subtract(12, "months");
    var openingDate = moment_default()(searchResults.first_open, "MMM YYYY");
    var isPreOpening = searchResults.pre_opening;
    var isFutureOpen = openingDate.isAfter(today) && !isPreOpening;
    var isPastOpen = openingDate.isAfter(lastYear) && openingDate.isBefore(today);
    if (isFutureOpen) {
        Badges.push("Opening ".concat(openingDate.format("MMM YYYY")));
    }
    if (isPastOpen) {
        Badges.push("Opened ".concat(openingDate.format("MMM YYYY")));
    }
    if (Badges.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Badges_module_default()).container,
        children: Badges.map(function(badge, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Badges_module_default()).badge,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Small */.x4, {
                    color: "white",
                    weight: "demiBold",
                    children: badge
                })
            }, index);
        })
    });
};
/* harmony default export */ var TravelSearchResults_Badges = (Badges);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react-material-ui-carousel/dist/index.js
var dist = __webpack_require__(13056);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./components/simple-carousel/_SimpleCarousel.module.scss
var _SimpleCarousel_module = __webpack_require__(85147);
var _SimpleCarousel_module_default = /*#__PURE__*/__webpack_require__.n(_SimpleCarousel_module);
// EXTERNAL MODULE: ./components/icons/index.ts + 18 modules
var icons = __webpack_require__(30918);
;// CONCATENATED MODULE: ./components/simple-carousel/constants.ts
var DEFAULT_CAROUSEL_SETTINGS = {
    infinite: false,
    maxVisibleDots: 5,
    enableSwipe: true
};
var MAX_IMAGES_IN_CAROUSEL = 100;

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/simple-carousel/carousel-dots/constants.ts
var DOT_WIDTH = 7;
var DOT_GAP = 8;
var DOT_STEP = DOT_WIDTH + DOT_GAP;
var CONTAINER_MARGIN = 2;

;// CONCATENATED MODULE: ./components/simple-carousel/carousel-dots/helpers.ts

/**
 * Calculate which dots should be visible and their offset for animation
 */ function calculateVisibleDots(currentIndex, totalSlides) {
    var maxVisible = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    if (totalSlides <= maxVisible) {
        return {
            dots: Array.from({
                length: totalSlides
            }, function(_, i) {
                return i;
            }),
            offset: 0
        };
    }
    var start;
    var offset;
    // Start of carousel - show first maxVisible dots
    if (currentIndex <= 2) {
        start = 0;
        offset = 0;
    } else if (currentIndex >= totalSlides - 3) {
        start = totalSlides - maxVisible;
        offset = -(totalSlides - maxVisible) * DOT_STEP;
    } else {
        start = currentIndex - 2;
        offset = -start * DOT_STEP;
    }
    return {
        dots: Array.from({
            length: maxVisible
        }, function(_, i) {
            return start + i;
        }),
        offset: offset
    };
}
/**
 * Calculate container width for dots
 */ function calculateDotsContainerWidth(visibleCount) {
    return "calc(".concat(visibleCount, " * ").concat(DOT_WIDTH, "px + (").concat(visibleCount, " - 1) * ").concat(DOT_GAP, "px + ").concat(CONTAINER_MARGIN, "px)");
}

;// CONCATENATED MODULE: ./components/simple-carousel/carousel-dots/CarouselDots.tsx





var CarouselDots = function(param) {
    var totalItems = param.totalItems, currentIndex = param.currentIndex, _maxVisibleDots = param.maxVisibleDots, maxVisibleDots = _maxVisibleDots === void 0 ? 5 : _maxVisibleDots, onDotClick = param.onDotClick;
    var ref = calculateVisibleDots(currentIndex, totalItems, maxVisibleDots), visibleDots = ref.dots, offset = ref.offset;
    var containerWidth = calculateDotsContainerWidth(visibleDots.length);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (_SimpleCarousel_module_default()).carouselDots,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (_SimpleCarousel_module_default()).carouselDotsContainer,
            style: {
                transform: "translateX(".concat(offset, "px)"),
                width: containerWidth
            },
            children: Array.from({
                length: totalItems
            }, function(_, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: classnames_default()((_SimpleCarousel_module_default()).carouselDot, (0,_define_property/* default */.Z)({}, (_SimpleCarousel_module_default()).carouselDotActive, i === currentIndex)),
                    onClick: function() {
                        return onDotClick(i);
                    },
                    "aria-label": "Go to slide ".concat(i + 1),
                    "aria-current": i === currentIndex ? "true" : "false",
                    style: {
                        opacity: visibleDots.includes(i) ? 1 : 0,
                        pointerEvents: visibleDots.includes(i) ? "auto" : "none"
                    }
                }, "dot-".concat(i + 1));
            })
        })
    });
};
/* harmony default export */ var carousel_dots_CarouselDots = (CarouselDots);

;// CONCATENATED MODULE: ./components/simple-carousel/carousel-dots/index.ts


;// CONCATENATED MODULE: ./components/simple-carousel/helpers.ts
/**
 * Determine which images should be loaded for smooth transitions
 */ function shouldLoadImage(imageIndex, currentIndex, totalSlides) {
    var infinite = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    // Always load current image
    if (imageIndex === currentIndex) {
        return true;
    }
    // Load adjacent images for smooth transitions
    var isPrevSlide = infinite ? imageIndex === (currentIndex - 1 + totalSlides) % totalSlides : imageIndex === currentIndex - 1;
    var isNextSlide = infinite ? imageIndex === (currentIndex + 1) % totalSlides : imageIndex === currentIndex + 1;
    return isPrevSlide || isNextSlide;
}
/**
 * Calculate next slide index based on navigation direction
 */ function calculateNextIndex(currentIndex, direction, totalSlides) {
    var infinite = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var nextIndex = currentIndex + direction;
    if (infinite) {
        return (nextIndex + totalSlides) % totalSlides;
    }
    if (nextIndex >= 0 && nextIndex < totalSlides) {
        return nextIndex;
    }
    return null;
}
/**
 * Determine if drag gesture should trigger navigation
 */ function calculateDragNavigation(dragDistance) {
    var threshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 50;
    var absDist = Math.abs(dragDistance);
    return {
        shouldNavigate: absDist > threshold,
        direction: dragDistance > 0 ? 1 : -1
    };
}

;// CONCATENATED MODULE: ./components/simple-carousel/SimpleCarousel.tsx












var SimpleCarousel = function(param) {
    var images = param.images, _settings = param.settings, settings = _settings === void 0 ? {} : _settings, linkTo = param.linkTo;
    var mergedSettings = (0,_object_spread/* default */.Z)({}, DEFAULT_CAROUSEL_SETTINGS, settings);
    var slides = (0,react.useMemo)(function() {
        return images.slice(0, MAX_IMAGES_IN_CAROUSEL);
    }, [
        images
    ]);
    var infinite = mergedSettings.infinite, maxVisibleDots = mergedSettings.maxVisibleDots, enableSwipe = mergedSettings.enableSwipe;
    var ref = (0,react.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:768px)");
    var goToSlide = (0,react.useCallback)(function(index) {
        var total = slides.length;
        var direction = index - currentIndex;
        var nextIndex = calculateNextIndex(currentIndex, direction, total, infinite);
        if (nextIndex !== null) {
            setCurrentIndex(nextIndex);
        }
    }, [
        currentIndex,
        slides.length,
        infinite
    ]);
    var handleCarouselChange = (0,react.useCallback)(function(slide) {
        if (slide !== undefined && slide !== currentIndex) {
            setCurrentIndex(slide);
        }
    }, [
        currentIndex
    ]);
    var renderSlide = function(image, index) {
        var shouldLoad = shouldLoadImage(index, currentIndex, slides.length, infinite);
        if (!shouldLoad) {
            return null;
        }
        var slideContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageComponent/* Image */.E, {
            src: image.url,
            alt: "carousel slide ".concat(index + 1),
            style: {
                aspectRatio: "16/9",
                maxWidth: "100%",
                maxHeight: "270px",
                width: "100%",
                height: "100%",
                objectFit: "cover"
            }
        }, "slide-".concat(image.url, "-").concat(index));
        return linkTo ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: linkTo,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: linkTo,
                className: (_SimpleCarousel_module_default()).carouselSlidesLink,
                children: slideContent
            })
        }, "slide-".concat(image.url, "-").concat(index)) : slideContent;
    };
    var carouselContent = /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
        autoPlay: false,
        animation: "slide",
        navButtonsAlwaysVisible: !isMobile,
        indicators: true,
        cycleNavigation: infinite,
        height: enableSwipe ? 250 : 270,
        swipe: enableSwipe,
        className: (_SimpleCarousel_module_default()).carousel,
        PrevIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowLeft */.Xd, {}),
        NextIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowLeft */.Xd, {
            className: (_SimpleCarousel_module_default()).next
        }),
        activeIndicatorIconButtonProps: {
            className: (_SimpleCarousel_module_default()).active
        },
        indicatorContainerProps: {
            className: (_SimpleCarousel_module_default()).hide
        },
        navButtonsProps: {
            className: (_SimpleCarousel_module_default()).navPosition
        },
        navButtonsWrapperProps: {
            className: (_SimpleCarousel_module_default()).navButtonWrapper
        },
        onChange: handleCarouselChange,
        index: currentIndex,
        children: slides.map(function(img, i) {
            return renderSlide(img, i);
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (_SimpleCarousel_module_default()).carouselContainer,
        style: {
            height: enableSwipe ? 250 : 270
        },
        children: [
            carouselContent,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_dots_CarouselDots, {
                totalItems: slides.length,
                currentIndex: currentIndex,
                maxVisibleDots: maxVisibleDots,
                onDotClick: goToSlide
            })
        ]
    });
};
/* harmony default export */ var simple_carousel_SimpleCarousel = (SimpleCarousel);

;// CONCATENATED MODULE: ./components/simple-carousel/index.ts


;// CONCATENATED MODULE: ./blocks/TravelSearchResults/ListItemExtended.tsx











var ListItemExtended = function(param) {
    var searchResults = param.searchResults;
    var view_hotel_text = (0,useLocalised/* default */.Z)(translationKeys.view_hotel);
    var hotelName = searchResults.name;
    var hotelImage = searchResults.image;
    var hotelId = searchResults.id;
    var hotelDetailsUrl = "/our-hotels/".concat(hotelId);
    var _images;
    var hotelImages = ((_images = searchResults.images) !== null && _images !== void 0 ? _images : []).map(function(img) {
        return {
            url: typeof img === "string" ? img : img.url
        };
    });
    var showImageCarousel = hotelImages.length > 1;
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:600px)");
    var isTouchDevice = (0,useMediaQuery/* default */.Z)("(hover: none) and (pointer: coarse)");
    var isLargeScreen = (0,useMediaQuery/* default */.Z)("(min-width:1024px)");
    var canSwipe = isTouchDevice || isMobile || !isLargeScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (ListItemExtended_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ListItemExtended_module_default()).image,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelSearchResults_Badges, {
                        searchResults: searchResults
                    }),
                    showImageCarousel && /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_carousel_SimpleCarousel, {
                        images: hotelImages,
                        settings: {
                            enableSwipe: canSwipe
                        },
                        linkTo: hotelDetailsUrl
                    }),
                    !showImageCarousel && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: hotelDetailsUrl,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: hotelDetailsUrl,
                            className: (ListItemExtended_module_default()).hotelImageLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageComponent/* Image */.E, {
                                src: hotelImage,
                                alt: "".concat(hotelName, " image"),
                                style: {
                                    aspectRatio: "89/50",
                                    maxWidth: "100%",
                                    maxHeight: "270px",
                                    width: "100%",
                                    height: "100%"
                                }
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ListItemExtended_module_default()).hotelInfoContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: hotelDetailsUrl,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: hotelDetailsUrl,
                                    className: (ListItemExtended_module_default()).hotelNameLink,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        children: hotelName
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "extra-small",
                                children: searchResults.location
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ListItemExtended_module_default()).hotelInfo,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Benefits_Benefits, {
                                benefits: searchResults.benefits,
                                benefitsFootnotes: searchResults.benefitsFootnotes
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ListItemExtended_module_default()).hotelCTA,
                                children: [
                                    searchResults.pre_opening && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ListItemExtended_module_default()).preOpening,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "demi-bold",
                                                children: "Expected opening"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (ListItemExtended_module_default()).firstOpen,
                                                children: searchResults.first_open
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: hotelDetailsUrl,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: hotelDetailsUrl,
                                            className: "".concat((ListItemExtended_module_default()).hotelButtonLink, " ").concat((ListItemExtended_module_default()).button),
                                            children: view_hotel_text
                                        })
                                    }),
                                    searchResults.benefitsFootnotes.length > 0 && isMobile && searchResults.benefitsFootnotes.map(function(footNote, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ListItemExtended_module_default()).footNotesRow,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Small */.x4, {
                                                xs: true,
                                                color: "grey-dark",
                                                children: footNote
                                            })
                                        }, index);
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TravelSearchResults_ListItemExtended = (ListItemExtended);

// EXTERNAL MODULE: ./components/container/index.ts
var container = __webpack_require__(49985);
// EXTERNAL MODULE: ./components/divider/index.ts
var divider = __webpack_require__(81367);
;// CONCATENATED MODULE: ./blocks/TravelSearchResults/TravelSearchResults.tsx








var TravelSearchResults = function(param) {
    var searchResults = param.searchResults;
    var results_found_text = (0,useLocalised/* default */.Z)(translationKeys.results_found);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        mt: 35,
        mb: 70,
        className: (TravelSearchResults_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                mb: 15,
                children: "".concat(searchResults.length, " ").concat(results_found_text)
            }),
            searchResults.map(function(result, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
                    className: (TravelSearchResults_module_default()).resultsContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelSearchResults_ListItemExtended, {
                            searchResults: result
                        }),
                        index !== searchResults.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {
                            color: "gold-dark",
                            mt: 30,
                            mb: 30
                        })
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var TravelSearchResults_TravelSearchResults = (TravelSearchResults);


/***/ }),

/***/ 69028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var components_shared_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63057);
/* harmony import */ var components_text_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13394);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);






var Divider = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "div" : _as, _direction = _param.direction, direction = _direction === void 0 ? "h" : _direction, _height = _param.height, height = _height === void 0 ? 1 : _height, width = _param.width, style = _param.style, _color = _param.color, color = _color === void 0 ? "grey-medium" : _color, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "as",
        "direction",
        "height",
        "width",
        "style",
        "color",
        "children"
    ]);
    var marginStyle = (0,components_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .getMarginFromProps */ .X)(rest);
    var colorStyle = (0,components_text_utils__WEBPACK_IMPORTED_MODULE_1__/* .getColorFromString */ .T)(color);
    var backgroundColor = colorStyle || (style === null || style === void 0 ? void 0 : style.backgroundColor);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createElement)(as, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, marginStyle, style), {
            width: width,
            height: height,
            backgroundColor: backgroundColor
        })
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 81367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Divider__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Divider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69028);



/***/ }),

/***/ 96731:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Badges_container__a1vLG","badge":"Badges_badge__rp5by"};

/***/ }),

/***/ 20010:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ListItemExtended_container__lkHPz","hotelImageLink":"ListItemExtended_hotelImageLink__243kw","hotelNameLink":"ListItemExtended_hotelNameLink__xCJ5B","hotelButtonLink":"ListItemExtended_hotelButtonLink__ckf8_","hotelInfoContainer":"ListItemExtended_hotelInfoContainer__oV72T","hotelInfo":"ListItemExtended_hotelInfo__92xHS","hotelCTA":"ListItemExtended_hotelCTA__4_5Mx","preOpening":"ListItemExtended_preOpening__56PPK","firstOpen":"ListItemExtended_firstOpen__8Qor0","button":"ListItemExtended_button__kH__2","footNotesRow":"ListItemExtended_footNotesRow__xWkZi","image":"ListItemExtended_image__oL_gR"};

/***/ }),

/***/ 56270:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"TravelSearchResults_container__RakGw","resultsContainer":"TravelSearchResults_resultsContainer__7ymbb","line":"TravelSearchResults_line__Haqko","results":"TravelSearchResults_results__yGHst","footNoteContainer":"TravelSearchResults_footNoteContainer__WUH_I"};

/***/ }),

/***/ 69013:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"benefitsContainer":"Benefits_benefitsContainer__b70KN","benefitsRow":"Benefits_benefitsRow__JmDSL","footNotesRow":"Benefits_footNotesRow__9bGdy","footNotesContainer":"Benefits_footNotesContainer__yj6P_"};

/***/ }),

/***/ 85147:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"_SimpleCarousel_carouselContainer__00Koj","carouselSlidesLink":"_SimpleCarousel_carouselSlidesLink__o9Eeh","carouselSlideLink":"_SimpleCarousel_carouselSlideLink__JDSDN","carousel":"_SimpleCarousel_carousel__uFjIG","active":"_SimpleCarousel_active__kDmyb","hide":"_SimpleCarousel_hide__E20LX","navPosition":"_SimpleCarousel_navPosition__c0B22","next":"_SimpleCarousel_next__2QGNh","navButtonWrapper":"_SimpleCarousel_navButtonWrapper__gm_cf","carouselDots":"_SimpleCarousel_carouselDots___w7dB","carouselDotsContainer":"_SimpleCarousel_carouselDotsContainer___w9gm","carouselDot":"_SimpleCarousel_carouselDot__ZYVUl","carouselDotActive":"_SimpleCarousel_carouselDotActive__0Ha5f"};

/***/ })

}]);